import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl,
  cibGithub,
  cilAt,
  cilHome,
  cilLayers,
  cilLockLocked,
  cilTerminal,
  cilUser,
  cilMap,
  cilNewspaper,
  cilLocationPin,
  cilChartLine,
  cilGraph,
  cilCompass,
  cilTags,
  cilAsterisk,
  cilBell,
  cilStar,
  cilInfo,
  cilSpeech,
  cilCloudDownload,
  cilDescription,
  cilCog
} from "@coreui/icons"
export const iconsSet = Object.assign({
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl,
  cibGithub,
  cilAt,
  cilHome,
  cilLayers,
  cilLockLocked,
  cilTerminal,
  cilUser,
  cilMap,
  cilNewspaper,
  cilLocationPin,
  cilChartLine,
  cilGraph,
  cilCompass,
  cilTags,
  cilAsterisk,
  cilBell,
  cilStar,
  cilInfo,
  cilSpeech,
  cilCloudDownload,
  cilDescription,
  cilCog
})
